export const plansData = [
    {
        name: 'Basic',
        prices: ['19.99', '199.99'],
        features: [
            '500 GB Storage',
            '2 Users Allowed',
            'Send up to 3 GB'
        ],
    },
    {
        name: 'Professional',
        prices: ['24.99', '249.99'],
        features: [
            '1 TB Storage',
            '5 Users Allowed',
            'Send up to 10 GB'
        ],
    },
    {
        name: 'Master',
        prices: ['39.99', '399.99'],
        features: [
            '2 TB Storage',
            '10 Users Allowed',
            'Send up to 20 GB'
        ],
    },
]